(() => {
  const main = document.querySelector('main.content-for-layout[data-template]');
  if (!main) return;

  const template = main.dataset.template || '';
  const isTargetTemplate = template === 'index' || template === 'page.concept';
  if (!isTargetTemplate) return;

  const revealSelectors = [
    '[data-template="index"] .hero__content-wrapper > *',
    '[data-template="index"] .hyt-intro-vertical__blocks',
    '[data-template="index"] .section-resource-list__header > *',
    '[data-template="index"] .section-resource-list__content > *',
    '[data-template="index"] .featured-product-section .product-information__media',
    '[data-template="index"] .featured-product-section .featured-product-content-top',
    '[data-template="index"] .featured-product-section .featured-product-content-bottom',
    '[data-template="index"] .featured-product-section .product-details > *',
    '[data-template="page.concept"] .hyt-concept-heading__title',
    '[data-template="page.concept"] .hyt-concept-image-text__heading',
    '[data-template="page.concept"] .hyt-concept-image-text__content',
    '[data-template="page.concept"] .hyt-brand-introduction__side-image',
    '[data-template="page.concept"] .hyt-brand-introduction__content',
    '[data-template="page.concept"] .hyt-centenarian__box',
  ];

  const revealClass = 'hyt-reveal';
  const visibleClass = 'hyt-reveal--visible';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const parallaxSelector = '.hyt-wide-image--parallax';
  const parallaxElements = new Set();

  let observer;
  let parallaxTicking = false;

  const revealElement = (element) => {
    element.classList.add(visibleClass);
    if (observer) observer.unobserve(element);
  };

  const prepareElement = (element, index) => {
    if (element.classList.contains(revealClass)) return;

    element.classList.add(revealClass);
    element.style.setProperty('--hyt-reveal-delay', `${Math.min(index * 70, 280)}ms`);

    if (prefersReducedMotion) {
      revealElement(element);
      return;
    }

    if (observer) {
      observer.observe(element);
      return;
    }

    revealElement(element);
  };

  const prepareReveals = (root = main) => {
    const scope = root.matches?.('main.content-for-layout') ? root : main;
    const elements = scope.querySelectorAll(revealSelectors.join(','));

    elements.forEach((element, index) => {
      if (element.closest('#header-group, footer')) return;
      prepareElement(element, index);
    });
  };

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const updateParallax = () => {
    parallaxTicking = false;

    if (prefersReducedMotion || parallaxElements.size === 0) return;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    parallaxElements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const strength = Number.parseFloat(element.dataset.hytParallaxStrength || '70');
      const sectionCenter = rect.top + rect.height / 2;
      const viewportCenter = viewportHeight / 2;
      const progress = (sectionCenter - viewportCenter) / (viewportHeight + rect.height);
      const offset = clamp(progress * strength * -2, strength * -1, strength);

      element.style.setProperty('--hyt-wide-image-parallax-y', `${offset.toFixed(2)}px`);
    });
  };

  const requestParallaxUpdate = () => {
    if (parallaxTicking) return;
    parallaxTicking = true;
    window.requestAnimationFrame(updateParallax);
  };

  const prepareParallax = (root = main) => {
    if (prefersReducedMotion) return;

    const scope = root.matches?.('main.content-for-layout') ? root : main;
    scope.querySelectorAll(parallaxSelector).forEach((element) => {
      parallaxElements.add(element);
    });

    requestParallaxUpdate();
  };

  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) revealElement(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12,
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        prepareReveals();
        prepareParallax();
      },
      { once: true }
    );
  } else {
    prepareReveals();
    prepareParallax();
  }

  document.addEventListener('shopify:section:load', (event) => {
    prepareReveals(event.target);
    prepareParallax(event.target);
  });

  window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
  window.addEventListener('resize', requestParallaxUpdate);
})();
